export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Password"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Annulla"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Continua"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Inserisci la password di conferma"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Password di conferma"])}
}